<template>
  <transition name="notification">
    <div
      :class="classes"
      v-if="type && type.length"
      data-cy="feedback-notification"
    >
      <c-icon
        class="icon"
        v-if="icon || type"
        :icon="icon || icons[type]"
        size="21"
      />
      <section
        v-if="type === 'favorite' || type === 'like'"
        class="content"
      >
        <p class="text ">
          <b>Oferta {{ title }}</b><br class="notificationBR" /> {{ text }}
        </p>
      </section>
      <section
        v-else
        class="content"
      >
        <p class="title">
          {{ title }}
        </p>
        <p class="text">
          {{ text }}
        </p>
      </section>
      <c-button
        light-grey
        size="md"
        class="close"
        icon="cross"
        @click="$emit('close')"
      />
    </div>
  </transition>
</template>

<script>
const icons = {
  success: 'thumbs-up',
  error: 'warning',
  favorite: 'filled-bookmark',
  like: 'filled-heart'
}

export default {
  props: {
    type: {
      validator: value => ['', 'success', 'error', 'favorite', 'like'].includes(value)
    },
    title: String,
    text: String,
    icon: String
  },
  data () {
    return {
      icons,
      timeout: null
    }
  },
  computed: {
    classes () {
      const classes = [
        'c-notification', {
          ['-' + this.type]: true
        }]
      return classes
    }
  },
  mounted () {
    this.setCloseTimeout()
  },
  updated () {
    this.resetCloseTimeout()
  },
  methods: {
    setCloseTimeout () {
      this.timeout = setTimeout(() => { this.$emit('close') }, 5000)
    },
    resetCloseTimeout () {
      clearTimeout(this.timeout)
      setTimeout(() => { this.setCloseTimeout() }, 0)
    }
  }
}
</script>

<style lang='scss'>
@import '~@style/reference';

.c-notification {
  z-index: 80;
  position: fixed;
  left: 0;
  width: calc(100% - 20px);
  height: 70px;
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  border-radius: 3px;
  transform: translateY(0);
  transition: background-color 0.3s ease, transform 0.3s ease, opacity 0.3s ease;

  @include desktop {
    width: 450px;
    bottom: 0;
    margin: 10px;
  }

  @include mobile {
    top: 73px;
    margin: 0 10px;
  }

  & > .icon {
    margin: 20px;
    fill: white;
  }

  & > .content {
    margin-right: auto;

    & > .title,
    & > .text {
      color: white;
    }

    & > .title {
      font-weight: 600;
    }
  }

  & > .close {
    border: 1.5px solid white;
    margin: 20px;
    -moz-transition: border .1s;
    -o-transition: border .1s;
    -webkit-transition: border .1s;
    transition: border .1s;

    &:hover {
      border: 3px solid white;
    }
  }
  &.-success {
    background-color: $success-color;
  }
  &.-error {
    background-color: $failure-color;
  }
  &.-favorite {
    background-color: $c-like-success;
  }
  &.-like {
    background-color: $c-like-success;
  }
}

.notification-enter,
.notification-leave-to {
  opacity: 0;
  transform: translateY(100%);
  
  @include mobile {
    transform: translate(-50%, 0);
  }
}
.notificationBR{
   @include desktop {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CFeedback.vue